var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friend-list-container",class:{'default': !_vm.hasFriend}},[(_vm.hasFriend)?_c('div',_vm._l((_vm.friendList),function(friend){return _c('friend-item',{key:friend.userID,attrs:{"friend":friend}})}),1):_c('div',{staticStyle:{"color":"gray"}},[_vm._v("暂无好友")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28934af5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/im/friend/friend-list.vue
// module id = null
// module chunks = 